import React, { useRef, useMemo, useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Uno = styled.img`
  aspect-ratio: 71/69;
  width: auto;
  height: 80rem;
`;

const Dos = styled.img`
  aspect-ratio: 157/161;
  width: auto;
  height: 170rem;
`;

const Tres = styled.img`
  aspect-ratio: 245/229;
`;

const Blackberry = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null),
      tres: useRef<HTMLElement>(null),
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null),
      tres: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: useMemo(() => getVh("flavor", 0.70), []),
    dos: useMemo(() => getVh("flavor", 0.15), []),
    tres: useMemo(() => getVh("flavor", 0.45), [])
  }

  useAnimation(flavor === "blackberry", [ref.figure.uno, ref.figure.dos, ref.figure.tres]);

  useParallax(ref.img.uno, top.uno, 150);
  useParallax(ref.img.dos, top.dos, 50);
  useParallax(ref.img.tres, top.tres, 100);

  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ left: "90vw" }}
      >
        <Uno ref={ref.img.uno} src="/static/images/fill/blackberry/1.png" />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={{ right: "10rem" }}
      >
        <Dos ref={ref.img.dos} src="/static/images/fill/blackberry/2.png" />
      </Container>

      <Container
        ref={ref.figure.tres}
        top={top.tres}
        style={{ left: "50vw" }}
      >
        <Tres ref={ref.img.tres} src="/static/images/fill/blackberry/3.png" />
      </Container>
    </>
  );
}

export default Blackberry;